import { RouteRecordRaw } from 'vue-router';
import { SearchPage } from '@/pages/search';

export const routeName = 'Pesquisa';

export const route: RouteRecordRaw = {
  path: 'pesquisa',
  name: routeName,
  component: SearchPage,
};
